import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ensureCurrentUser } from '../../../util/data';
import { getVisitors } from '../VisitorsPage.helpers';

export const useVisitorsDataRequest = ({
    visitorsByType,
    representationListingId,
    callback = () => null,
}) => {
    const dispatch = useDispatch();
    const currentUser = useSelector(state => ensureCurrentUser(state.user.currentUser));

    useEffect(() => {
        const getVisitorsData = async () => {
            const visitors = await getVisitors({
                dispatch,
                visitors: visitorsByType,
                representationListingId,
                currentUser,
            });

            callback(visitors);
        };

        if (Array.isArray(visitorsByType) && visitorsByType.length > 0) {
            getVisitorsData();
        }
    }, [visitorsByType, representationListingId]);
};
